/**
 * Physical jewelry label — GC420t roll measured by shop:
 *   total 88 mm wide × 10 mm tall
 *
 *   |← empty 44 →|← Plata/Bs 19 →|← gap 5 →|← barcode 20 →|
 *   0            44               63        68             88
 *
 * The empty neck and its fold mark are physical (adhesive + wrap), so nothing
 * prints before 44 mm. Within the printable tail the price panel comes first
 * and the barcode sits flush with the end of the strip.
 */
export const LABEL_PRINT_WIDTH_MM = 88;
export const LABEL_PRINT_HEIGHT_MM = 10;
/** Physical fold mark on the empty neck (guide only). */
export const LABEL_FOLD_MM = 22;
/** Gap between labels on the physical roll (mm). */
export const LABEL_PRINT_GAP_MM = 3;

/** Empty left tail: adhesive + fold, never printed on. */
export const LABEL_EMPTY_MM = 44;

/** Panel 1: material + price. */
export const LABEL_INFO_LEFT_MM = LABEL_EMPTY_MM; // 44
export const LABEL_INFO_WIDTH_MM = 19;

/** Space after Plata/Bs; doubles as the barcode quiet zone. */
export const LABEL_AFTER_INFO_GAP_MM = 5;

/** Panel 2: code + barcode, flush with the end of the strip. */
export const LABEL_BARCODE_LEFT_MM =
  LABEL_INFO_LEFT_MM + LABEL_INFO_WIDTH_MM + LABEL_AFTER_INFO_GAP_MM; // 68
export const LABEL_BARCODE_WIDTH_MM = LABEL_PRINT_WIDTH_MM - LABEL_BARCODE_LEFT_MM; // 20

/** GC420t: 203 dpi → 8 dots per mm. */
export const LABEL_DOTS_PER_MM = 8;

export function mmToDots(mm: number): number {
  return Math.round(mm * LABEL_DOTS_PER_MM);
}
